module.exports = __webpack_public_path__ + "img/B2_HQ01.588c2643.jpg";